import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Input,
  Optional, Inject,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MediaObserver } from '@angular/flex-layout';
import { TranslateService } from '@ngx-translate/core';

import { APP_SELLER_LANDING_LINK } from '~shared/constants/links.constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { NavigationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationNavigationEventType } from '~shared/modules/application-event/constants';
import { MENU_EXTERNAL_LINKS, MetroxTrackingLabels } from '~app/modules/generic/constants';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { REQUEST } from '@nguniversal/express-engine/tokens';

@Component({
  selector: 'app-generic-header-topline-links',
  templateUrl: 'header-topline-links.component.html',
  styleUrls: ['header-topline-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderToplineLinksComponent implements OnInit, OnDestroy {
  externalLinks: any;
  isMobile: boolean;
  sellerLink = APP_SELLER_LANDING_LINK();
  private readonly destroySbj = new Subject();

  constructor(
    private readonly mediaObserver: MediaObserver,
    private readonly cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private applicationEventService: ApplicationEventService,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any) {
      const market = getCountryDomainCode(this.webAppBuyerRequest)
      this.externalLinks = Object.values(MENU_EXTERNAL_LINKS()[market]);
  }

  ngOnInit() {
    this.mediaObserver.asObservable()
      .pipe(
        takeUntil(this.destroySbj),
      )
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile)
          || this.mediaObserver.isActive(MEDIA_ALISES.tablet)
          || this.mediaObserver.isActive(MEDIA_ALISES.tabletLandscape);
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroySbj.next();
    this.destroySbj.complete();
  }

  onLinkClick(title: string, link: string): void {
    this.translateService.get(title)
      .pipe(takeUntil(this.destroySbj))
      .subscribe((translatedTitle: string) => {
        this.applicationEventService.publish(
          new NavigationApplicationEvent(
            ApplicationNavigationEventType.TopNavigationClick,
            translatedTitle,
            link
          )
        );
      });
  }

  handleExternalLinkTracking(label: string) {
    this.applicationEventService.publish(
      new NavigationApplicationEvent(
        ApplicationNavigationEventType.GlobalHeaderClick,
        MetroxTrackingLabels[label]
      )
    );
  }

  trackById(_, externalLink: any) {
    return externalLink.id;
  }
}
